import { Button, Flex, message, Modal, Table, Tabs, Tooltip, Typography } from "antd";
import { InventoryItem } from "../../../api/inventory/InventoryItem";
import { useState } from "react";
import { title } from "process";
import { usePutInventoryItemMutation } from "../../../api/inventory/inventoryApi";

export default function ItemDetailModal(props: {
  item: InventoryItem | null;
  onClose: () => void;
}) {
  const [msgApi, ctx] = message.useMessage();
  const [putItem] = usePutInventoryItemMutation();
  const [isRaw, setIsRaw] = useState(false);
  const dataTbl = props.item ? Object.entries(props.item).map(([key, value]) => ({
    key,
    value: typeof value === "object" ? JSON.stringify(value, null, 2) : String(value),
  })).toSorted((a, b) => a.key.localeCompare(b.key)) : [];
  const cols = [
    {
      title: "Field",
      dataIndex: "key",
      key: "key",
      width: 200,
    },
    {
      title: "Value",
      dataIndex: "value",
      key: "value",
      render: (text: string) => (
        <pre style={{ whiteSpace: "pre-wrap", wordBreak: "break-all", margin: 0 }}>
          {text}
        </pre>
      ),
    },
  ];

  function handleReturnInv() {
    if (!props.item) {
      return;
    }
    const conf = window.confirm(
      `Are you sure you want to return the item with ICCID ${props.item.Iccid} to inventory? This will remove its status and mark it as unused.`
    );
    if (!conf) {
      return;
    }

    const item = { ...props.item, Status: undefined, RedemptionOrderId: undefined, RedemptionSimIdx: undefined };
    putItem(item)
      .unwrap()
      .then(() => {
        msgApi.success("Item returned to inventory successfully.");
        props.onClose();
      })
      .catch((error) => {
        console.error("Error returning item to inventory:", error);
        msgApi.error("Failed to return item to inventory.");
      }
    );
  }

  console.log("props.item", props.item);

  console.log("dataTbl", dataTbl);
  return (
    <Modal
      title={props.item?.Iccid}
      open={props.item != null}
      onOk={props.onClose}
      onCancel={props.onClose}
      cancelButtonProps={{ style: { display: "none" } }}
      width={1000}
    >
      {ctx}
      <Tabs
        type="card"
        items={[
          {
            label: "Database",
            key: "database",
            children: (
              <>
                <Flex justify="space-between" align="center">
                  <Typography.Text>Database Details</Typography.Text>
                  <Button onClick={() => setIsRaw(!isRaw)}>
                    {isRaw ? "View Table" : "View Raw"}
                  </Button>
                </Flex>
                { isRaw &&
                  <pre style={{ whiteSpace: "pre-wrap", wordBreak: "break-all" }}>
                    {JSON.stringify(props.item, null, 2)}
                  </pre>
                }
                { !isRaw &&
                  <Table
                    columns={cols}
                    dataSource={dataTbl}
                    size="small"
                    pagination={{
                      pageSize: 10,
                      showSizeChanger: false,
                    }}
                  />
                }
              </>
            ),
          },
          {
            label: "Actions",
            key: "actions",
            children: (
              <Flex gap={8} vertical>
                <Flex justify="space-between" align="center">
                  <Typography.Text>Mark as Unused</Typography.Text>
                  { props.item?.Status &&
                    <Button type="primary" onClick={handleReturnInv}>
                      Mark as Unused
                    </Button>
                  }
                  { !props.item?.Status &&
                    <Tooltip title="This item is already marked as unused and may be reassigned.">
                      <Button type="primary" disabled>
                        Unavailable
                      </Button>
                    </Tooltip>
                  }
                </Flex>
              </Flex>
            ),
          },
        ]}
      />
    </Modal>
  );
}